import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect, Route, Switch} from "react-router-dom";
import {LocaleProvider} from "antd";
import {IntlProvider} from "react-intl";

import AppLocale from "lngProvider";
import MainApp from "./MainApp";
import SignIn from "../SignIn";
import {setInitUrl} from "appRedux/actions/Auth";

const RestrictedRoute = ({component: Component, ...rest, authUser}) =>
  
  
  
  <Route
    {...rest}
    render={ props =>
      authUser
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />}
  />;

class App extends Component {

  componentWillMount() {
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);

    }
  }



  render() {
    const {match, location, layoutType, locale, authUser, initURL} = this.props;

    if (location.pathname === '/') {
      if (authUser === null) { // authUser === null => es decir authUser === 0
        return ( <Redirect to={'/signin'}/> ); // no dejamos que acceda, lo redireccionamos
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        return ( <Redirect to={'/main/orders'}/> );
      } else {
        return ( <Redirect to={initURL}/> );
      }
    }



    // this.setLayoutType(layoutType); borrar

    const currentAppLocale = AppLocale[locale.locale]; // no borrar
    return (
      <LocaleProvider locale={currentAppLocale.antd}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}>

          <Switch>
            <Route exact path='/signin' component={SignIn}/>
            <RestrictedRoute path={`${match.url}`} authUser={authUser}
                             component={MainApp}/>
          </Switch>
        </IntlProvider>
      </LocaleProvider>
    )

  }


}

const mapStateToProps = ({settings, auth}) => {
  const {locale, layoutType} = settings; // no borrar
  const {authUser, initURL} = auth;
  return {locale, layoutType, authUser, initURL}
};
export default connect(mapStateToProps, {setInitUrl})(App);




// WEBPACK FOOTER //
// ./src/containers/App/index.js